export default __webpack_public_path__ + "static/media/co1.d2b03e5d.png";